(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-story-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = btn.getAttribute('data-story-toggle');
      var body = document.getElementById('storyBody-' + id);
      var expanded = body.classList.toggle('expanded');
      btn.textContent = expanded
        ? (btn.dataset.lessLabel || 'Show Less')
        : (btn.dataset.moreLabel || 'Read Full Story');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-suggest"] && !Shopify.designMode) return;
  try {
    
  window.theme = window.theme || {};

  theme.productSuggest = (function () {
    var productNotification = document.querySelector(".product-notification"),
        closeButtons = document.querySelectorAll(".close-notifi"),
        suggestionDuration = 0,
        suggestionCookie = "productSuggestClosed";

    if (productNotification) {
      suggestionDuration = parseInt(productNotification.getAttribute("data-time"), 10) || 0;
    }

    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
      var match = document.cookie.match("(?:^|; )" + name + "=([^;]*)");
      return match ? match[1] : null;
    }

    function closeSuggestion() {
      if (productNotification) {
        productNotification.remove();
      }
      setCookie(suggestionCookie, "closed", 1);
    }

    function toggleSuggestion() {
      if (!productNotification) return;

      if (productNotification.classList.contains("active")) {
        productNotification.classList.remove("active");
      } else {
        var productItems = document.querySelectorAll(".data-product");
        if (!productItems.length) return;

        var randomIndex = Math.floor(Math.random() * productItems.length),
            selectedProduct = productItems[randomIndex];

        productNotification.classList.add("active");

        var productImage = productNotification.querySelector(".product-image img");
        if (productImage) {
          // Only swap the src — DON'T set full-size width/height,
          // the fixed 100x100 CSS box + object-fit handles sizing.
          productImage.setAttribute("src", selectedProduct.getAttribute("data-image"));
          productImage.setAttribute("alt", selectedProduct.getAttribute("data-alt") || "");
        }

        var productImageLink = productNotification.querySelector(".product-image");
        if (productImageLink) {
          productImageLink.setAttribute("href", selectedProduct.getAttribute("data-url"));
          productImageLink.setAttribute("title", selectedProduct.getAttribute("data-title"));
        }

        var productName = productNotification.querySelector(".product-name");
        if (productName) {
          productName.textContent = selectedProduct.getAttribute("data-title");
          productName.setAttribute("href", selectedProduct.getAttribute("data-url"));
        }

        var timeAgo = productNotification.querySelector(".time-ago");
        if (timeAgo) {
          timeAgo.textContent = selectedProduct.getAttribute("data-time");
        }

        var fromAgo = productNotification.querySelector(".from-ago");
        if (fromAgo) {
          fromAgo.textContent = selectedProduct.getAttribute("data-local");
        }
      }
    }

    function handleSuggestionInterval() {
      if (suggestionDuration !== 0) {
        setInterval(toggleSuggestion, suggestionDuration);
      }
    }

    function init() {
      if (!productNotification) return;

      if (getCookie(suggestionCookie) === "closed") {
        productNotification.remove();
      } else {
        closeButtons.forEach(function (btn) {
          btn.addEventListener("click", closeSuggestion);
        });
        handleSuggestionInterval();
      }
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
